import InnerComponent from '@Components/Common/ViewPurchaseOrder';
import orgContainer from '@Components/AppContainer';

const ViewPurchaseOrder = () => ((orgContainer(InnerComponent)));
export default ViewPurchaseOrder;
